export default __webpack_public_path__ + "static/Kale-6365c65d0e9cdc66e95dfd6da69d89bf.jpg";